export default __webpack_public_path__ + "468e2a05aeec5154acc89b6c053fb5d6.png";